/**
 * Contact Form V2
 * Focuses success/error status after Shopify contact form submit.
 */
(() => {
  const init = () => {
    document.querySelectorAll('[data-contact-form-v2]').forEach((section) => {
      const status = section.querySelector('[data-contact-form-v2-status]');
      if (!status) return;

      const isSuccess = status.hasAttribute('data-success');
      const isError = status.hasAttribute('data-error');
      if (!isSuccess && !isError) return;

      status.setAttribute('tabindex', '-1');
      status.focus({ preventScroll: true });
      status.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('[data-contact-form-v2]')) {
      init();
    }
  });
})();
